module.exports = __webpack_public_path__ + "static/media/match-visualization.398577fb.svg";